export enum PrescriptionDrugInsuranceEnum {
  WholeYear = 'WHOLE_YEAR',
  PartOfTheYear = 'PART_OF_THE_YEAR',
  NeverInsured = 'NEVER_INSURED',


}
